/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */

import * as React from 'react';

import { ThemedLink } from '@helpcenter/themed-link';
import type { WrappedComponentProps } from 'react-intl-next';
import { injectIntl, FormattedMessage } from 'react-intl-next';
import { css, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import { getHelpCenterUrl, getLoginUrl } from '@atlassian/help-center-common-util/url';
import messages from './messages';

export interface CommentSubmittedProps {
    redirectToLogin: boolean;
}

export class CommentSubmitted extends React.Component<CommentSubmittedProps & WrappedComponentProps> {
    getHelpCenterUrl = () => {
        const url = getHelpCenterUrl();

        if (this.props.redirectToLogin) {
            const loginUrl = getLoginUrl({
                redirectUrl: url,
            });
            if (!loginUrl.startsWith('/')) {
                return `/${loginUrl}`;
            }
            return loginUrl;
        }
        return url;
    };

    render() {
        const { intl } = this.props;
        const linkUrl = this.getHelpCenterUrl();
        return (
            <>
                <FireScreenEventOnMount />
                <h3>{intl.formatMessage(messages.addedComment)}</h3>
                <div css={redirectDivStyles} data-test-id="request-feedback-comment-submitted">
                    <FormattedMessage
                        {...messages.redirectText}
                        values={{
                            helpCenterName: (
                                <ThemedLink to={linkUrl} actionSubjectId="helpCenterLink">
                                    {intl.formatMessage(messages.redirectLink)}
                                </ThemedLink>
                            ),
                        }}
                    />
                </div>
            </>
        );
    }
}

export default injectIntl(CommentSubmitted);

const redirectDivStyles = css({
    marginTop: token('space.050', '4px'),
});
